import * as React from "react";

import styles from "./IconText.module.css";

export interface IconTextProps {
  icon: string;
  text?: React.ReactNode;
  className?: string;
}

export const IconText: React.FC<IconTextProps> = ({ icon, text, className }) => (
  <span className={`${styles[`icon-text`]} ${className ?? ``}`}>
    <i className={icon} aria-hidden="true" />
    <span className="icon-text-label">{text}</span>
  </span>
);
